import {SpaceProto} from "../../../../core/model2/space/space-proto";


export class SpaceSearch {

    public space        : SpaceProto
    public reRender     : callback

    public searchValue  : string     = ''
    public isActive     : boolean    = false


    constructor(space: SpaceProto, reRender:callback) {
        this.space      = space
        this.reRender   = reRender

    }

    get enabled():boolean {

        return this.searchValue.length > 0

    }

    get searchResults() {
        return this.space.search(this.searchValue)
    }

}
